import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "./components/routing/router";
import { Toaster } from "./components/ui/toaster";
import { ToasterProvider } from "./components/providers/toaster-provider";
import { ModalProvider } from "./components/providers/modal-provider";
import { LocalStorageProvider } from "./components/providers/local-storage-provider";

function App() {
  return (
    <ToasterProvider>
      <ModalProvider>
        <LocalStorageProvider>
          <Toaster />
          <RouterProvider router={router} />
        </LocalStorageProvider>
      </ModalProvider>
    </ToasterProvider>
  );
}

export default App;
